var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeOwnBossIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "be_own_boss_icn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 80,
    cy: 68,
    r: 23
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "be_own_boss_icn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "punctuality-icon",
    transform: "translate(9.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,6 L1,71 C1,74.8659932 4.13400675,78 8,78 L84,78 C87.8659932,78 91,74.8659932 91,71 L91,6 L1,6 Z",
    id: "Rectangle",
    stroke: "#2E2D2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#2E2D2E",
    strokeWidth: 2,
    cx: 80,
    cy: 68,
    r: 22
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "79 58 79 70.1862303 86 77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,16.5 L2,16.5",
    id: "Path-4",
    stroke: "#2E2D2E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(9.000000, 28.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 13.7580872,
    cy: 2.16666667,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 25.257384,
    cy: 2.16666667,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 36.7566807,
    cy: 2.16666667,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 48.2559775,
    cy: 2.16666667,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 60.0632911,
    cy: 1.85714286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 70.8438819,
    cy: 2.16666667,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 13.7580872,
    cy: 13.7222222,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 25.257384,
    cy: 13.7222222,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 36.7566807,
    cy: 13.7222222,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 48.2559775,
    cy: 13.7222222,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 60.0632911,
    cy: 13.9285714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 13.7580872,
    cy: 25.2777778,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 25.257384,
    cy: 25.2777778,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 36.7566807,
    cy: 25.2777778,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#AFB1B3",
    cx: 13.7580872,
    cy: 36.8333333,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 2.25879044,
    cy: 13.7222222,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 2.25879044,
    cy: 25.2777778,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 2.25879044,
    cy: 36.8333333,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 25.257384,
    cy: 36.8333333,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    stroke: "#2E2D2E",
    cx: 36.7566807,
    cy: 36.8333333,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,0 L80.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,0 L68.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,0 L57.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,0 L45.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,0 L34.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,0 L22.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0 L11.5,10",
    id: "Line",
    stroke: "#2E2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeOwnBossIcn);
export default __webpack_public_path__ + "static/media/be_own_boss_icn.1b28ef9dbdc5dfbf9f2fa7ea4d3bbf0c.svg";
export { ForwardRef as ReactComponent };